/**
 * Add confirmation to subscription cancellation
 */

jQuery(document).ready(function($) {
	
	$('body.woocommerce-account.logged-in .subscription_details .button.suspend').click(function(e){
		if ( !confirm('Are you sure you want to suspend this subscription?') ) {
			e.preventDefault();
		}
	});

	$('body.woocommerce-account.logged-in .subscription_details .button.cancel').click(function(e) {
		if ( !confirm('Are you sure you want to cancel this subscription? You will be cancelling the upcoming renewal order and if you need more immediate assistance, please contact customerserv@vousvitamin.com') ) {
			e.preventDefault();
		} 
	});

});
